var DateLongNames = {
		day : [
			FmtMessage.getMessage('js.datepicker.day.longname.0'),
			FmtMessage.getMessage('js.datepicker.day.longname.1'),
			FmtMessage.getMessage('js.datepicker.day.longname.2' ),
			FmtMessage.getMessage('js.datepicker.day.longname.3' ),
			FmtMessage.getMessage('js.datepicker.day.longname.4' ),
			FmtMessage.getMessage('js.datepicker.day.longname.5' ),
			FmtMessage.getMessage('js.datepicker.day.longname.6')
		],    
		month : [
			FmtMessage.getMessage('js.month.name.0' ),
			FmtMessage.getMessage('js.month.name.1' ),
			FmtMessage.getMessage('js.month.name.2' ),
			FmtMessage.getMessage('js.month.name.3' ),
			FmtMessage.getMessage('js.month.name.4' ),
			FmtMessage.getMessage('js.month.name.5' ),
			FmtMessage.getMessage('js.month.name.6' ),
			FmtMessage.getMessage('js.month.name.7' ),
			FmtMessage.getMessage('js.month.name.8' ),
			FmtMessage.getMessage('js.month.name.9' ),
			FmtMessage.getMessage('js.month.name.10' ),
			FmtMessage.getMessage('js.month.name.11' )
		]
}